<template>
  <div :id="`modal-${modalId}`">
    <MadModal
      :id="modalId"
      :data-cy="`${modalId}-modal`"
      :options="options"
      @opened="onOpened"
      @closed="onClosed"
    >
      <div class="modal-body">
        <b-tabs
          v-model="tabIndex"
          no-key-nav
        >
          <template>
            <b-tab :title="`${this.$i18n.t('JSON.networks')}`">
              <div class="v-table">
                <TableServer type="networks" />
              </div>
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.add-network')}`">
              <NetworkForm v-if="fetcherAdminSchemas.forms['Network']" />
            </b-tab>
            <b-tab
              v-if="networkId !== null && fetcherAdminNetwork.id > 0"
              :title="`${this.$i18n.t('JSON.network')}#${networkId}`"
            >
              <NetworkForm
                v-if="fetcherAdminSchemas.forms['Network']"
                :network="fetcherAdminNetwork"
                mode="edit"
              />
            </b-tab>
          </template>
        </b-tabs>
      </div>
    </MadModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import formHelpers from '@/mixins/admin/helpers/form-helpers';
import modalHelpers from '@/mixins/admin/helpers/modal-helpers';

export default {


  components: {
    MadModal: () => import('@/components/MadModal'),
    NetworkForm: () => import('@/components/admin/fetcher/modals/forms/NetworkForm'),
  },

  mixins: [
    formHelpers, //
    modalHelpers,
  ],

  props: {
    networkId: {
      type: Number,
      default: () => 0,
    },
  },

  data() {
    return {
      options: {
        width: '75%',
        //   height: '95%',
      },
    };
  },

  computed: {
    ...mapState({
      fetcherAdminNetwork: (state) => state.fetcherAdminNetwork.fetcherAdminNetwork,
    }),

    modalId() {
      return 'network';
    },
  },

  watch: {
    networkId(newValue) {
      if (newValue !== null) {
        this.loadFetcherAdminNetwork();
      }
    },
  },

  methods: {
    ...mapActions(['getFetcherAdminNetwork']),

    async loadFetcherAdminNetwork() {
      try {
        await this.getFetcherAdminNetwork({
          params: {
            nid: this.networkId,
          },
        });

        // console.log('network', this.network);

        // success
        // console.log('success loading network!');
      } catch (error) {
        // error
        // console.log('error loading network!');
      }
    },

    onOpened() {
      if (this.networkId !== null) {
        this.loadFetcherAdminNetwork();
      }

      this.modalOpened();
    },

    onClosed() {
      this.modalClosed();
    },
  },
};
</script>
